import { Injectable, inject, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/services/auth.service';

@Injectable()
export class FastrApiInterceptor implements HttpInterceptor {
  private static logoutInProgress = false;
  private injector = inject(Injector);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isFastrApiRequest = request.url.startsWith(environment.API_BASE_URL);
    const apiRequest =
      isFastrApiRequest && !request.withCredentials
        ? request.clone({ withCredentials: true })
        : request;

    return next.handle(apiRequest).pipe(
      catchError((error: unknown) => {
        if (isFastrApiRequest && error instanceof HttpErrorResponse && this.shouldLogout(error)) {
          this.logout();
        }

        return throwError(() => error);
      }),
    );
  }

  private shouldLogout(error: HttpErrorResponse): boolean {
    return error.status === 401;
  }

  private logout(): void {
    if (FastrApiInterceptor.logoutInProgress) {
      return;
    }

    FastrApiInterceptor.logoutInProgress = true;
    this.injector.get(AuthService).logout();
  }
}
